import { Box } from '@mui/material';
import { FC } from 'react';
import { BluContainerBlockInterface } from './interface';
import '../../styles/container-block.css';

const BluContainerBlock: FC<BluContainerBlockInterface> = ({
  children,
  sx = {},
  ...rest
}) => {
  return (
    <Box
      className="blu-container-block"
      sx={{ display: 'flex', ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default BluContainerBlock;
